
























































































































































































































































import store from './store'
import {
    //touchScreen,
    update
} from './mixins/mixins'
import {
    isTestMode,
    openLinkInBrowser,
    platform,
    linking
} from './mla-shared/';
import { IsEnabled } from './common/constants';
const version = require('../package.json').version

export default {
    mixins: [update], // touchScreen
    data(this: any) {
        return {
            testing: isTestMode(),
            drawer: null,
            disable: false,
            clearLocalStorage: true,
            //isTouchScreen: this.detect(),
            platform: platform(),
            version: version,
			offset: window.pageYOffset,
			IsEnabled,
            breakpoint: this.$vuetify.breakpoint
        }
    },

    methods: {
        // Reset all data
        resetData: function (this: any) {
            store.dispatch('resetState', this.clearLocalStorage)
            this.$router.push({ name: 'Home' })
        },

        // Disable reset warning
        resetDisable: function (this: any) {
            if (this.disable === true) {
                store.dispatch('resetDisable', true)
            }
        },

        // Set test data from ../data/test/test-data.json
        /*setTestData: async function (this: any) {
            if (this.testing) {
                const TESTDATA = require("./data/test/test-data.json");
                if (await this.$refs.confirm.open(
                        'Load Test Data',
                        'Are you sure you want to load test data?',
                        {
                            color: 'blue',
                            cta: 'Load data'
                        }
                )) {
                    Object.assign(store.state.pasture, TESTDATA.pasture)
                    Object.assign(store.state.cattle, TESTDATA.cattle)
                    Object.assign(store.state.sheep, TESTDATA.sheep)
                    window.location.reload()
                }
            }
        },*/

        // Confirm navigation to eLearning module
        elearning: async function (this: any) {
            if (await this.$refs.confirm.open(
                'eLearning: Pasture Utilisation Course',
                'Learn how to identify any constraints in the utilisation of your pastures and put in place actions to enable you to lift stock numbers and better manage green pasture utilisation on grazed land.',
                {
                    color: 'blue',
                    width: 400,
                    cta: 'View Course'
                }
            )) {
                openLinkInBrowser('https://elearning.mla.com.au/courses/pasture-utilisation/');
            }
        },

        // Navigate back to etools domain
        etools() {
            openLinkInBrowser('https://etools.mla.com.au/');
        },

        // eTools email link
        support() {
            linking({
                operation: 'openURL',
                openURL: 'mailto:tools@mla.com.au',
            });
        },

        // Survery link
        survey() {
            openLinkInBrowser('https://forms.office.com/Pages/ResponsePage.aspx?id=HJuCo77s1EmI6U8o95r6EVSRkmKU9bNPpUHjjT0BiexUQzNUQzBMRlgxREFMUjFYTTBBTUhEWFlFVS4u');
        },

        // Disable tab links based on conditions
        disableLink(this:any, name:('livestock' | 'feed')) {
            if (name === 'livestock') {
                // No pasture simulation created
                if (store.state.pasture === null) {
                    return true
                }
                // Pasture errors exist
                if (store.state.errors.pasture && store.state.errors.pasture.length > 0) {
                    return true
                }
                // No enterprise selected
                if (store.state.pasture.simulation.enterprise === null) {
                    return true
                }
                // Missing pasture types
                if (store.state.pasture.simulation.growthRateSource === 'Add Pasture Types' && store.state.pasture.simulation.pastures.filter(p => p.type === null).length > 0) {
                    return true
                }
                // Default
                return false
            }

            if (name === 'feed') {
                // No pasture simulation created
                if (!store.state.pasture) {
                    return true
                }
                // Pasture or Livestock errors exist
                if ((store.state.errors.pasture && store.state.errors.pasture.length > 0) || (store.state.errors.livestock && store.state.errors.livestock.length > 0)) {
                    return true
                }
                // No enterprise selected
                if (!store.state.pasture.simulation.enterprise) {
                    return true
                }
                // No Livestock created for cattle enterprise
                if (store.state.pasture.simulation.enterprise === 'Cattle') {
                   if (!store.state.cattle || !store.state.cattle.livestock) {
                       return true
                    // No distinct join dates
                    } else if (
                        (store.state.cattle.livestock.joinNumber <= 2 && (store.state.cattle.livestock.joinPeriods[0].fromDate === store.state.cattle.livestock.joinPeriods[0].toDate)) ||
                        (store.state.cattle.livestock.joinNumber === 2 && (store.state.cattle.livestock.joinPeriods[1].fromDate === store.state.cattle.livestock.joinPeriods[1].toDate))
                    ) {
                        return true
                    // Empty inventory
                    } else if (store.state.cattle.stock.filter((s:any) => s.startNumber > 0 || s.purchaseNumber > 0).length <= 0) {
                        return true
                    }
                }
                // No Livestock created for sheep enterprise
                if (store.state.pasture.simulation.enterprise === 'Sheep') {
                    if (!store.state.sheep || !store.state.sheep.livestock) {
                        return true
                    // No distinct join dates
                    } else if (
                        (store.state.sheep.livestock.joinNumber <= 2 && (store.state.sheep.livestock.joinPeriods[0].fromDate === store.state.sheep.livestock.joinPeriods[0].toDate)) ||
                        (store.state.sheep.livestock.joinNumber === 2 && (store.state.sheep.livestock.joinPeriods[1].fromDate === store.state.sheep.livestock.joinPeriods[1].toDate))
                    ) {
                        return true
                    // Empty inventory
                    } else if (store.state.sheep.stock.filter((s:any) => s.startNumber > 0 || s.purchaseNumber > 0).length <= 0) {
                        return true
                    }
                }
                // One or more missing livestock for cattle & sheep enterprise
                if ((store.state.pasture.simulation.enterprise === 'Cattle & Sheep' && !store.state.cattle) ||
                (store.state.pasture.simulation.enterprise === 'Cattle & Sheep' && !store.state.sheep)) {
                    return true
                }
                // Default
                return false
            }
        }
    },

    mounted() {
        window.onscroll = () => {
            (this as any).offset = window.pageYOffset;
        }
        // console.log(this.breakpoint)
    },

    destroyed() {
        window.onscroll = null;
    },

    store
}
